module.exports = __webpack_public_path__ + "img/24.25a22bc5.jpg";